/** Portal publishing fields carried by each file format (spec D2). */
export interface FileFormatPortalFields {
  isForPortal?: boolean;
  portalCode?: string;
  portalDescription?: string;
  portalCategory?: 'direct' | 'indirect' | 'customs' | 'nontax' | null;
}

export class Service {
  id: number;
  name: string;
  code: string;
  type: string;
  defaultFileFormat: string;
  defaultCurrency: string;
  defaultBankAccount: string;
  mcasURL : string;
  canCreateCompanies: boolean;
  // Master switch: a format is public only if this AND its own isForPortal are set.
  isForPortal: boolean;
  // Each entry also carries FileFormatPortalFields.
  fileFormats: object[];
}
